import CustomContextPad from './CustomContextPad';
import CustomPalette from './CustomPalette';
import CustomPopupMenu from './CustomPopupMenu';

const data = {
  __init__: [ 'customContextPad', 'customPalette', 'customPopupMenu' ],
  customContextPad: [ 'type', CustomContextPad ],
  customPalette: [ 'type', CustomPalette ],
  customPopupMenu: [ 'type', CustomPopupMenu ]
};

export default data;